module.exports = __webpack_public_path__ + "27861f42069fd1d782d399efdfc6fabe.jpg";